import { useAsync } from 'react-use'
import type { BigNumber } from '@ethersproject/bignumber'

export default function useHodlPrpsBurnCalculator(
  totalBalance?: BigNumber,
  lockedBalance?: BigNumber,
  price?: string
) {
  const state = useAsync(async () => {
    if (!totalBalance || !lockedBalance || !price) {
      return
    }
    const unlockedBalance = totalBalance.sub(lockedBalance)

    // Has enough unlocked PRPS to cover the transaction,
    // no need to spend any locked PRPS
    if (unlockedBalance.gte(price)) {
      return
    }

    const lockedPrpsNeededWei = unlockedBalance.sub(price).abs()
    if (
      // Anomalies
      lockedPrpsNeededWei.isNegative() ||
      lockedPrpsNeededWei.isZero() ||
      // Not enough locked PRPS
      lockedBalance.lt(lockedPrpsNeededWei)
    ) {
      return
    }

    const { formatEther } = await import('@ethersproject/units')

    return formatEther(lockedPrpsNeededWei)
  }, [totalBalance, lockedBalance, price])

  return { amount: state.value }
}
